<template>
  <div>
    <DataGetter
      @dataAvailable="
        data => {
          rawStats = data?.metaData
        }
      "
      contentId="stats"
    />
    <div class="flex justify-around h-[17rem] items-end relative">
      <div class="absolute h-full w-full top-0 left-0 pointer-events-none">
        <div
          class="border-b absolute w-full border-dashed border-slate-100"
          v-for="(el, i) in new Array(7).fill('')"
          :key="i"
          :class="{
            'top-[calc(100%*0/6)]': i == 0,
            'top-[calc(100%*1/6)]': i == 1,
            'top-[calc(100%*2/6)]': i == 2,
            'top-[calc(100%*3/6)]': i == 3,
            'top-[calc(100%*4/6)]': i == 4,
            'top-[calc(100%*5/6)]': i == 5,
            'top-[calc(100%*6/6)]': i == 6,
          }"
        ></div>
      </div>
      <div
        v-for="(el, i) in stats"
        :key="i"
        class="w-[7%] group h-full flex group flex-col justify-end"
      >
        <div
          class="w-full min-h-[5%] rounded-xl bg-[#F5F6FA] hover:bg-primary relative duration-300 flex items-center justify-center"
          :style="{ height: `${(el.amount * 100) / ((maxValue / 6) * 8)}%` }"
        >
          <div class="absolute top-full translate-y-[1rem]">
            {{ el.shortName }}
          </div>
          <div
            class="h-[80%] w-full absolute bottom-0 bg-[#F1F4FF] rounded-lg md:rounded-xl"
            style="
              background-image: url(/images/linepattern.svg);
              background-size: 15px;
              background-position: top left;
            "
          ></div>
          <div
            class="absolute top-0 flex items-center justify-center group-hover:z-[3]"
          >
            <div
              class="absolute w-3 h-3 border-2 rounded-full bg-white border-[#FF7955] duration-300 opacity-0 group-hover:opacity-100 group-hover:delay-150"
            ></div>
            <div
              class="pointer-events-none bottom-4 absolute bg-white px-4 py-2 border rounded-xl shadow-b-2xl z-[2] whitespace-nowrap translate-y-1/2 group-hover:translate-y-0 duration-300 opacity-0 group-hover:opacity-100"
              :class="{
                '-translate-x-[20%]': i == stats.length - 1,
                '-translate-x-[10%]': i == stats.length - 2,
                'translate-x-[20%]': i == 0,
                'translate-x-[10%]': i == 1,
              }"
            >
              <div>{{ el.name }}</div>
              <div class="font-bold text-lg title-color">
                {{ el.val }} Transactions
              </div>
              <div class="font-bold text-lg title-color">
                <CurrencyConverter :amount="el.amount"/>
                <!-- {{ el.amount }} CFA -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="h-[3rem]"></div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import DataGetter from '../utils/DataGetter.vue'
import CurrencyConverter from '../appComponent/CurrencyConverter.vue';

export default defineComponent({
  name: 'PlatformStats',
  components: { DataGetter, CurrencyConverter },
  props: {
    period: {
      type: Object,
      default() {
        return { id: '', formatId: '' }
      },
    },
  },
  data() {
    return {
      rawStats: null,
      months: [
        'Janvier',
        'Février',
        'Mars',
        'Avril',
        'Mai',
        'Juin',
        'Juillet',
        'Aout',
        'Septembre',
        'Octobre',
        'Novembre',
        'Décembre',
      ],
    }
  },
  mounted() {},
  methods: {},
  computed: {
    stats() {
      const stats = (this.rawStats || {})[this.period?.id] || null
      return (
        stats?.map(stat => {
          let date, month, year
          let [v1, v2, v3] = stat.periodId.split('-')
          if (!!v3) {
            date = v1
            month = v2
            year = v3
          } else if (!!v2) {
            month = v1
            year = v2
          } else year = v1

          let name = ''
          let shortName = ''
          if (this.period.formatId == 'month') {
            name = `${this.months[parseInt(month) - 1]} ${year}`
            shortName = `${this.months[parseInt(month) - 1].slice(0, 3)}`
          }

          if (this.period.formatId == 'day') {
            name = `${date} ${this.months[parseInt(month) - 1]}`
            shortName = `${date}`
          }

          return {
            name,
            shortName,
            val: stat.amount,
            amount: stat.amount,
          }
        }) || Array(12).fill({ name: '', shortName: '', val: 0, amount: 0 })
      )
    },
    maxValue() {
      return Math.max(...this.stats.map(stat => stat.amount))
    },
  },
})
</script>
